import { PostHogProvider } from "posthog-js/react"
import { initPostHog } from "@/lib/analytics/posthog"
import { AppRecovery } from "@/components/app/AppRecovery"
import { CapacitorStatusBar } from "@/components/app/CapacitorStatusBar"
import { UpdateNotification } from "@/components/app/UpdateNotification"
import { UploadKeepAwake } from "@/components/app/UploadKeepAwake"
import { getActiveProject } from "@/hooks/useActiveProject"
import { Toaster } from "@fieldbook/ui/toaster"
import {
  createRootRouteWithContext,
  Outlet,
  redirect,
} from "@tanstack/react-router"
import React from "react"
import posthog from "posthog-js"

const TanStackRouterDevtools = import.meta.env.DEV
  ? React.lazy(() =>
      // Lazy load in development
      import("@tanstack/router-devtools").then((res) => ({
        default: res.TanStackRouterDevtools,
        // For Embedded Mode
        // default: res.TanStackRouterDevtoolsPanel
      })),
    )
  : () => null // Render nothing in production

export const Route = createRootRouteWithContext<{
  isLoggedIn: boolean
}>()({
  beforeLoad: async ({ params, matches }) => {
    const activeProject = getActiveProject()
    if (activeProject) {
      if (!("id" in params) || activeProject !== params.id) {
        if (
          matches.find((m) => m.fullPath === "/scan/$tagCode") &&
          "tagCode" in params
        ) {
          throw redirect({
            to: "/projects/$id/scan/$tagCode",
            params: { id: activeProject, tagCode: params.tagCode as string },
          })
        } else {
          throw redirect({
            to: `/projects/$id`,
            params: { id: activeProject },
          })
        }
      }
    }
  },
  component: RoootComponent,
})

const enableTanStackDevTools = false // import.meta.env.DEV
initPostHog()

function RoootComponent() {
  return (
    <PostHogProvider client={posthog}>
      <div className="h-full min-h-0">
        <CapacitorStatusBar />
        <AppRecovery />
        <Outlet />
        <UpdateNotification />
        <UploadKeepAwake />
        {enableTanStackDevTools && <TanStackRouterDevtools />}
        <Toaster />
      </div>
    </PostHogProvider>
  )
}
